module.exports = __webpack_public_path__ + "officialStatic/img/pf5.333152c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/pf5.png
// module id = HuYM
// module chunks = 0